/**
 * Checkpoint summary types used by Threads, Stories, and ContentItems.
 * Summaries can be daily, weekly, or overall.
 */

import { z } from 'zod';

export const CheckpointKindSchema = z.enum(['daily', 'weekly', 'overall']);
export type CheckpointKind = z.infer<typeof CheckpointKindSchema>;

export const CheckpointSummarySchema = z.object({
  id: z.string(),
  kind: CheckpointKindSchema,
  /** ISO date for daily (YYYY-MM-DD), ISO week for weekly, null for overall */
  periodKey: z.string().nullable(),
  summary: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type CheckpointSummary = z.infer<typeof CheckpointSummarySchema>;
